import React, { Component } from "react";
import InputBox from "components/InputBox";
import { TextFieldValidator } from "components/InputBox/TextFieldValidator";

export default class ChartTagLowerLimitRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.getValue() || ""
    };
  }
  changeHandler = newValue => {
    const processedValue = newValue === "" ? null : parseFloat(newValue);
    this.setState({ value: newValue });

    const { rowIndex, data } = this.props.node;
    this.props.node.setData({ ...data, Ylower: processedValue, isEdited: true });
    this.props.context.updateChartView("Ylower");
  };

  getValue = () => {
    return this.props.node.data.Ylower !== undefined && this.props.node.data.Ylower !== null ? this.props.node.data.Ylower.toString() : "";
  };

  clearInput = () => {
    this.changeHandler("");
  };

  render() {
    return (
      <InputBox
        value={this.state.value}
        onChange={this.changeHandler}
        validator={TextFieldValidator.NUMBER_WITH_DECIMALS_AND_NEGATIVE}
        placeholder="Lower Limit"
        customClass="chart-limits"
        clearInput={this.clearInput}
        maxLength={15}
      />
    );
  }
}
